export function getCsrfToken() {
  let metalist = document.getElementsByTagName('meta')
  for (let ii = 0; ii < metalist.length; ii++) {
    let elem = metalist[ii]
    if (elem.name === 'csrf-token') {
      return elem.content
    }
  }
}
